/* eslint-disable no-console */
/* eslint-disable no-var */
/* eslint-disable func-names */
/* eslint-disable no-unused-vars */
/* eslint-disable vars-on-top */
/* eslint-disable object-shorthand */
/* eslint-disable no-undef */
/* eslint-disable arrow-parens */
/* eslint-disable global-require */
import 'babel-polyfill';
import Vue from 'vue';
import Router from 'vue-router';
import Vuex from 'vuex';
// import home from '@/components/home';
// import articleView from '@/components/articleView';
// import notFound from '@/components/notFound';
// import tagResult from '@/components/tagResult';

Vue.use(Router);
Vue.use(Vuex);

const home = resolve => {
  require.ensure(['@/components/home'], () => {
    resolve(require('@/components/home'));
  });
};
const redirect = resolve => {
  require.ensure(['@/components/redirect'], () => {
    resolve(require('@/components/redirect'));
  });
};
const notfound = resolve => {
  require.ensure(['@/components/notfound'], () => {
    resolve(require('@/components/notfound'));
  });
};
const EventPage = resolve => {
  require.ensure(['@/components/eventPage'], () => {
    resolve(require('@/components/eventPage'));
  });
};


export default new Router({
  mode: 'history',
  routes: [
    {
      // path: '/vd/staging/',
      path: '/',
      name: 'Home',
      component: home,
    },
    {
      // path: '/vd/staging/',
      path: '/en',
      name: 'HomeEn',
      component: home,
    },
    {
      // path: '/vd/staging/',
      path: '/tc',
      name: 'HomeTc',
      component: home,
    },
    {
      path: '/brandvideo',
      redirect: to => {
        window.location.replace('https://www.facebook.com/victoriadockside/videos/1736693966365330');
      },
    },
    {
      path: '/brandvideo/',
      redirect: to => {
        window.location.replace('https://www.facebook.com/victoriadockside/videos/1736693966365330');
      },
    },
    {
      path: '/video/',
      redirect: to => {
        window.location.replace('https://www.facebook.com/victoriadockside/videos/1736693966365330');
      },
    },
    {
      path: '/event/',
      name: 'EventPage',
      component: EventPage,
    },
    {
      path: '/en/event/',
      name: 'EventPageEn',
      component: EventPage,
    },
    {
      path: '/tc/event/',
      name: 'EventPageTc',
      component: EventPage,
    },
    {
      path: '*',
      name: 'notfound',
      component: notfound,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js